import { useState } from "react";

import { CButton, CInput } from "src/common/components/controls";

export const SearchComboItem = ({ onSearch }) => {
  //#region Data
  const [input, setInput] = useState("");
  //#endregion

  //#region Event
  const onChange = (value) => setInput(value);

  const handleSearch = () => onSearch(input);
  //#endregion

  //#region Render
  return (
    <div className="flex flex-1 flex-row gap-2 items-end mb-2">
      <CInput
        value={input}
        onChange={onChange}
        onEnter={handleSearch}
        className="flex-1"
        label="Nhập tên combo"
        placeholder="Tìm kiếm theo tên combo item"
      />
      <CButton onClick={handleSearch}>Tìm kiếm</CButton>
    </div>
  );
  //#endregion
};
